import gql from 'graphql-tag'

export const fetchBonusesList = () => {
	return {
		query: gql`
			{
				bonuses(order_by: { valid_from: desc }) {
					id
					title
					country {
						code
					}
					company {
						company_name
					}
					valid_from
					valid_until
					active
				}
			}
		`,
		update(data) {
			return data.bonuses.map(item => ({
				id: item.id,
				title: item.title,
				countryCode: item.country.code,
				company: item.company.company_name,
				valid_from: this.$moment(item.valid_from).format('DD-MM-YYYY'),
				valid_until: this.$moment(item.valid_until).format('DD-MM-YYYY'),
				edit: true,
				active: item.active
			}))
		}
	}
}
